import { CommonModule, formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-update-reservation-status-dialog',
  templateUrl: './update-reservation-status-dialog.component.html',
  styleUrls: ['./update-reservation-status-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatIcon,
    MatButtonModule
  ]
})
export class UpdateReservationStatusDialogComponent implements OnInit {

  statusForm!: FormGroup;

  selectedReservations!: any[];
  cancelReservation: boolean = false;
  activeAndCancelledReservations: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdateReservationStatusDialogComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.selectedReservations = this.data;

    let isCancel = this.selectedReservations.some(reservation => reservation.status_id === 5 || reservation.status_id === 8);
    let isUncancel = this.selectedReservations.some(reservation => reservation.status_id === 3);
    if (isCancel && !isUncancel) {
      this.cancelReservation = true;
    }
    if (!isCancel && isUncancel) {
      this.cancelReservation = false;
    }
    if (isCancel && isUncancel) {
      this.cancelReservation = true;
      this.activeAndCancelledReservations = true;
    }
    this.initForm();
  }

  initForm() {
    this.statusForm = this.formBuilder.group({
      cancel_date: [new Date()]
    });
  }

  submitUpdateReservationStatus(cancelReservation: boolean) {
    let statusId: number = 0;
    if (cancelReservation) {
      statusId = 3;
    } else {
      statusId = 8;
    }

    let statusPayload = {
      statusDate: formatDate(this.statusForm.get('cancel_date')?.value, 'MM/dd/yyyy', 'en-US', 'UTC'),
      statusId: statusId
    }
    this.dialogRef.close(statusPayload);
  }

  cancelUpdateReservationStatus() {
    this.dialogRef.close(0);
  }
}